// extracted by mini-css-extract-plugin
export default {"skeleton-col":"f2bb9b","skeleton-col-content":"b849ff","skeleton-media-col":"afd5f5","skeleton-media-content":"a2545f"};